import React, { useEffect } from 'react';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import SharedDeviationPage from '@wix/da-shared-react/pkg/DeviationPage';
import { useScrollRestore } from '@wix/da-shared-react/pkg/Duperbrowse/hooks/useScrollRestore';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { DuperbrowseViewContext } from '@wix/da-shared-react/pkg/Duperbrowse/DuperbrowseViewContext';
import fbNotificationsRenderer from '@wix/da-feedback-shared/pkg/SystemNotifications/notificationsRenderFunc';
import { PapiDeviation } from '@wix/da-papi-types';
import './App.scss';

export interface Props {
  language: string;
  deviation?: PapiDeviation;
  isDuperbrowseActive?: boolean;
  isFeedbackPageOpen?: boolean;
  environment?: RuntimeEnvironment;
  appLoaded: () => void;
}

const App: React.FC<Props> = ({
  language,
  deviation,
  isFeedbackPageOpen,
  isDuperbrowseActive,
  environment,
  appLoaded,
}) => {
  useEffect(() => {
    appLoaded();
  }, [appLoaded]);

  useScrollRestore(!!isFeedbackPageOpen);

  return (
    <DaApp
      language={language}
      environment={environment}
      backToTopOffset={0}
      isDuperbrowseEnabled={false}
      disablePageWideNotifications
      notificationsRenderFunc={fbNotificationsRenderer}
      ncContextProps={{
        PageComponent: FeedbackPageLoadable,
        DrawerComponent: DrawerLoadable,
      }}
    >
      <ErrorBoundary debugComponent="DeviationApp">
        {isFeedbackPageOpen ? (
          <FeedbackPageLoadable />
        ) : (
          <DuperbrowseViewContext.Provider
            value={isDuperbrowseActive ? 'fullscreen' : undefined}
          >
            <SharedDeviationPage
              deviation={deviation}
              environment={environment}
            />
          </DuperbrowseViewContext.Provider>
        )}
      </ErrorBoundary>
    </DaApp>
  );
};
App.displayName = 'App';

export default App;
